import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { CREATOR_REPORTS_ALL_RESPONSES } from '../../constants';
import Event from 'models/Event';
import { EventQuestionType } from 'models/EventQuestionType';
import { ResponseSorts } from 'components/creator-report/ResponseSorts';

import { EditSwitch, EnableSectionUpsell, EditArrowSection } from './MainContent';
import ResponsesList from './ResponsesList';

class AllResponsesSection extends React.PureComponent {
  render() {
    const {
      event,
      responses,
      editing,
      sections,
      isAllResponsesVisuallyEnabled,
      isAllResponsesEnabled,
      handleAllResponsesSwitchChanged,
      handleOnSectionsSet,
      index,
      isPdfRender
    } = this.props;

    const hasResponses = (responses && responses.length > 0);
    const questionType = Event.getQuestionType(event);
    const isOpenEnded = EventQuestionType.isOpenEndedType(questionType);
    const votingMode = Event.getVotingMode(event);
    const allResponses = hasResponses ? (votingMode === 'star-rating' ? ResponseSorts.sortByMostTotalRatingTopLevel(responses) : ResponseSorts.sortByMostPopularTopLevel(responses)) : [];

    return (isAllResponsesEnabled || editing) && !EventQuestionType.isMultipleRatingType(Event.getQuestionType(event)) && (
      <div
        className={`report-card-wrapper col ${allResponses.length === 0
          ? 'page-break-avoid'
          : ''}`}>
        <div className="row no-gutters">
          <div className={`report-wrapper col${editing ? '-11' : ''}`}>
            <div className={`report-card ${!editing ? 'report-border' : ''}`}>
              {editing && (
                <div className="editing">
                  <EditSwitch
                    id={CREATOR_REPORTS_ALL_RESPONSES}
                    checked={isAllResponsesVisuallyEnabled}
                    onChange={handleAllResponsesSwitchChanged}
                  />
                </div>
              )}
              <div
                className={`card-title text-truncate ${editing && 'editing-title'}`}>
                {EventQuestionType.isStackRankType(Event.getQuestionType(event)) ? 'COMMENTS' : 'SESSION DETAILS'}
              </div>

              {((isAllResponsesEnabled && !editing) ||
                (editing && isAllResponsesVisuallyEnabled)
              ) ?
                <ResponsesList event={event} responses={allResponses} isPdfRender={ isPdfRender } />
                : editing
                  ? (
                    <EnableSectionUpsell
                      content={`Show the full list of user ${isOpenEnded
                        ? 'responses'
                        : 'comments'} in the report.`} />
                  )
                  : null
              }
            </div>
            {editing && (
              <EditArrowSection
                name="all_responses"
                sections={sections}
                onSectionsSet={handleOnSectionsSet}
                editing={editing}
                index={index} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

AllResponsesSection.propTypes = {
  event: PropTypes.object.isRequired,
  responses: PropTypes.array.isRequired,
  editing: PropTypes.bool.isRequired,
  sections: PropTypes.array.isRequired,
  isAllResponsesVisuallyEnabled: PropTypes.bool.isRequired,
  isAllResponsesEnabled: PropTypes.bool.isRequired,
  handleAllResponsesSwitchChanged: PropTypes.func.isRequired,
  handleOnSectionsSet: PropTypes.func.isRequired,
  isPdfRender: PropTypes.bool
};

export default AllResponsesSection;
